// Scroll ke elemen konten yang dibagikan dan beri sorotan sementara
export function focusShared(elementId, attempt = 0) {
  const el = document.getElementById(elementId);
  if (!el) {
    if (attempt < 10) setTimeout(() => focusShared(elementId, attempt + 1), 300);
    return;
  }
  setTimeout(() => {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add("share-highlight");
    setTimeout(() => el.classList.remove("share-highlight"), 4500);
  }, 150);
}
